import teacher1 from '../assets/teacher1.jpg';
import teacher2 from '../assets/teacher2.jpeg';
import teacher3 from '../assets/teacher3.jpg';
import teacher4 from '../assets/teacher4.jpg';

export const MENTORS = [
  { img: teacher2, name: 'Vijay', subject: 'IB & IGCSE Math' },
  { img: teacher4, name: 'Sanjay', subject: 'SAT English & UCAT' },
  { img: teacher3, name: 'Malavika', subject: 'NEET Chemistry & AP Bio' },
  { img: teacher1, name: 'Aditya', subject: 'JEE & AP Physics' },
];